import packageJson from '../../package.json';
import { initSign, getSign } from '@didi/wsgsig';

/** 根据url获得参数 */
const getAllSearchParamsByUrl = (url: string) => {
  const href = url;
  if (!href.includes('?')) return undefined;
  let params = {};
  const searchParams = href.split('?')[1];
  searchParams.split('&').forEach(item => {
    const [key, value] = item.split('=');
    if (key !== 'tab') {
      params[key] = decodeURIComponent(value);
    }
  });
  return params;
};

/** 初始化ddh05参数 */
const initParams = {
  bizId: '994ea8c6f7752f5616a834ab893fcc58', // 业务线：能源-充电-开放平台  业务名：epower-open
  appVer: packageJson.version, //当前程序的版本号，跟程序的版本号同步，方便问题排查时定位版本tag
  os: '4',
};

/** 过滤undefined */
function filterUndefined(object: object) {
  return Object.fromEntries(Object.entries(object).filter(([_, v]) => v !== undefined));
}

/** null转为'' */
function turnNull(object: object) {
  return Object.fromEntries(Object.entries(object).map(([_, v]) => (v === null ? [_, ''] : [_, v])));
}

export default () => {
  initSign(initParams);
};

export function useInterceptors(config) {
  /** 请求头中添加dd05签名：只针对GET、POST请求进行覆盖
   *  getSign参数字段：(params | body)、contentType
   *  1. params: GET请求url后的query参数
   *  2. body：POST请求
   *  3. contentType：body参数类型，只对参数类型 application/x-www-form-urlencoded ｜ application/json 做覆盖
   */
  /** signParams的原则： params和body必须和传给接口的一致 */
  if (!config.headers) {
    config.headers = {};
  }
  const signParams: Record<string, unknown> = {
    contentType: config.headers?.['Content-Type'],
  };

  /** 如果有params传入 */
  if (config.params) {
    signParams.params = turnNull(filterUndefined(config.params));
  }

  /** 如果url中有query参数，需要加入params中 */
  if (getAllSearchParamsByUrl(config.url)) {
    signParams.params = Object.assign(signParams.params || {}, getAllSearchParamsByUrl(config.url));
  }

  /** 如果contentType命中覆盖类型 */
  if (
    ['application/x-www-form-urlencoded', 'application/json'].some(item =>
      config.headers?.['Content-Type']?.includes(item),
    ) &&
    config.body
  ) {
    const data = JSON.parse(config.body);
    signParams.body = Array.isArray(data) ? data : filterUndefined(data);
  }
  console.log('signParams', signParams);

  const sign = getSign(signParams);
  config.headers.wsgsig = sign;
  return config;
}
